<!-- Overlay -->
<div (click)="toggleSidebar()" class="fixed inset-0 bg-black/40 z-40 ">
</div>

<!-- Sidebar -->
<div
  class="fixed top-0 left-0 h-full w-64 bg-white shadow-lg transform transition-transform duration-300  animation-slide-left"
  style="z-index: 999;">

  <!-- Header -->
  <div class="p-4 border-b border-slate-200 relative">
    <img src="\cityparking-01.png" alt="City Parking Logo" />
  </div>

  <!-- Menu -->
  <nav class="flex flex-col relative overflow-y-auto h-[calc(100vh-80px)]">
    <div *ngFor="let category of sidebarList">
      <div class="px-2 h-12 border-b border-gray-200 flex justify-between items-center space-x-2 " [ngClass]="{
            'shadow'  : checkOpenCategory(category.categoryEN)
          }" (click)="toggleCategory(category.categoryEN)">
        <p class="text-gray-500 font-semibold">{{ currentLang === "TH" ? category.categoryTH : category.categoryEN }}
        </p>
        <div class="h-4 w-4 mr-2">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJklEQVR4nO3XPUrGQBSF4VHQQizkw2UN9yByd6DZgPZZhNi4CsFWEdzB54aUKYQoCSHGSSbj+0CakHDnnPyREAAAAAAAAABgQIzxXNKtmV2Ewki6lHTj7rtcMw4k7SV9pM3M7tO+XMOmrCutpbOu9yzrcvfd15CCSvgWvrOdZZlmZk8FlTAU/jHbxBjjiZk99wx9aNv2MCwnPY53PRfjzd1Ps06O65ewXvgCSlg//IollBN+hRLKC79gCeWGX6CE8sNnLGE74TOUsL3w3RIkvcwoYbvh/6CE7YefUUI94X9RQn3hJ5RQb/gfX4fXvl/pvl/adGw6J9QkDt8J9V75qSVUHX6shH8RfuidUOUzP8bdj83sWtJV0zRHoycAAAAAAAAAQJjvE84t+EzeJB3rAAAAAElFTkSuQmCC"
            alt="expand-arrow">
        </div>
      </div>
      <div *ngFor="let list of category.list">
        <div *ngIf="checkOpenCategory(category.categoryEN)"
          (click)="list.disable ? null : onClickNavigateTo(list.route)"
          class="flex items-center gap-2 text-gray-700 hover:text-green-600 transition border-b border-slate-200 px-2 py-3 relative"
          [ngClass]="{ 'text-yellow-500 bg-yellow-100 bg-opacity-50 rounded-md': currentUrl === list.route }">
          <div class="bg-gray-200 rounded-full p-2"
            [ngClass]="{ 'bg-yellow-400 bg-opacity-50': currentUrl === list.route }">
            <img src="{{ list.imageSlide }}" class="w-5 h-5" *ngIf="currentUrl !== list.route" />
            <img src="{{ list.imageActive }}" class="w-5 h-5" *ngIf="currentUrl === list.route" />
          </div>
          <p class="text-sm font-semibold text-gray-500" [ngClass]="{ 'text-yellow-500': currentUrl === list.route }">
            {{ currentLang === "TH" ? list.nameTH : list.nameEN }}
          </p>
          <!------------------------------ ปิดปรับปรุง ---------------------------->
          <div class="bg-black/50 absolute top-0 left-0 w-full h-full flex justify-center items-center"
            style="z-index: 2;" *ngIf="list.disable">
            <p class="text-white">{{ currentLang === "TH" ? list.disableTextTH : list.disableTextEN}}</p>
          </div>
        </div>
      </div>
    </div>


  </nav>
</div>